
import React from 'react';
import Plans from '../../components/Plans';
import { Language, Plan } from '../../types';

interface PlansTemplateProps {
  isOpen: boolean;
  onClose: () => void;
  onActivationSuccess: (planType: 'pro' | 'enterprise') => void;
  language: Language;
  plans: Plan[];
}

const PlansTemplate: React.FC<PlansTemplateProps> = (props) => {
  return (
    <Plans 
      isOpen={props.isOpen}
      onClose={props.onClose}
      onActivationSuccess={props.onActivationSuccess}
      language={props.language}
      plans={props.plans}
    />
  );
};

export default PlansTemplate;
